import React, { useEffect, useState } from 'react';
import { Form, Input, Button, message, notification, Upload, Progress } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import axios from 'axios';

const CourseForm = ({ course, fetchCourses, onClose }) => {
  axios.defaults.withCredentials = true;
  const [form] = Form.useForm();
  const [api, contextHolder] = notification.useNotification();
  const [uploadProgress, setUploadProgress] = useState(0);
  const [pdfFile, setPdfFile] = useState(null);

  useEffect(() => {
    form.resetFields();
    if (course) {
      form.setFieldsValue(course);
      setPdfFile(null);
    }
  }, [course, form]);

  const handleSubmit = async (values) => {
    const formData = new FormData();
    formData.append('_id', values.id);
    formData.append('title', values.title);
    formData.append('content', values.content);
    if (pdfFile) {
      formData.append('pdf', pdfFile);
    }

    try {
      const url = `${process.env.REACT_APP_BACKEND_URI}/api/v1/admin/course/${course ? 'updatecourse' : 'newcourse'}`;
      const method = course ? 'post' : 'post';

      await axios({
        method,
        url,
        data: formData,
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setUploadProgress(percentCompleted);
        },
      });

      message.success(`${course ? 'Course updated' : 'Course added'} successfully`);
      fetchCourses();
      onClose();
      setUploadProgress(0);
    } catch (err) {
      console.error(err);
      api.error({
        message: err.response?.data?.message || err.message || 'Error occurred',
      });
      setUploadProgress(0);
    }
  };

  const customRequest = ({ file }) => {
    setPdfFile(file);
  };

  return (
    <>
      {contextHolder}
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item name="id" hidden>
          <Input />
        </Form.Item>
        <Form.Item name="title" label="Title" rules={[{ required: true, message: 'Please enter the course title' }]}>
          <Input />
        </Form.Item>
        <Form.Item name="content" label="Content" rules={[{ required: true, message: 'Please enter the course content' }]}>
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item name="pdf" label="PDF File">
          <Upload customRequest={customRequest} showUploadList={false} maxCount={1}>
            <Button icon={<UploadOutlined />}>Select PDF</Button>
          </Upload>
          {uploadProgress > 0 && <Progress percent={uploadProgress} />}
        </Form.Item>
        <Form.Item>
          <Button  htmlType="submit"   className="gold-btn"
>
            {course ? 'Update' : 'Add'} Course
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default CourseForm;
